export default "__VITE_ASSET__bccb26ff__"